<template>
    <list v-if="creditContactStore.type == 1"></list>
    <create v-else-if="creditContactStore.type == 2"></create>
    <preview v-else-if="creditContactStore.type == 3"></preview>
    <edit v-else-if="creditContactStore.type == 4"></edit>
</template>

<script>
    import { useCreditContactStore } from '../../stores/CreditContactStore.js'
    import list from './ListComponent'
    import create from './CreateComponent'
    import preview from './PreviewComponent'
    import edit from './EditComponent'
    export default {
        props: {
        },
        components: {
            list,
            create,
            preview,
            edit
        },
        mounted() {
        },
        setup(props) {
            return {
                creditContactStore: useCreditContactStore(),
            }
        }
    }
</script>
